import ErrorBoundry from "./Error-Boundry";

export default ErrorBoundry;
